import { render } from "./List-Inbound.vue?vue&type=template&id=1ecf5239"
import script from "./List-Inbound.vue?vue&type=script&lang=js"
export * from "./List-Inbound.vue?vue&type=script&lang=js"

import "./List-Inbound.vue?vue&type=style&index=0&id=1ecf5239&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QTable from 'quasar/src/components/table/QTable.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSelect,QInput,QBtn,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QMarkupTable,QCheckbox,QPagination,QDialog,QCardActions,QTable});qInstall(script, 'directives', {ClosePopup});
